import Service from './abstract';
import _ from 'lodash';
import page from '../constants/pages/page';

const defaultOptions = {
    with: 'pending_request,status',
    pageSize: page.pageSize
};

const defaultOptionsRequests = {
    with: 'pending_request,status',
    pageSize: page.pageSize
};

const defaultOptionsRequestsStatus = {
    with: 'status',
    pageSize: page.pageSize
};

class Loans extends Service {
    constructor () {
        super('loans');
    }

    getLoans (options = {}) {
        return this.get({
            url: `${this.basePath}/loans`,
            qs: _.defaultsDeep(options, defaultOptions)
        });
    }

    getLoansRequest (options = {}) {
        return this.get({
            url: `${this.basePath}/loans/requests`,
            qs: _.defaultsDeep(options, defaultOptionsRequests)
        });
    }

    getLoansRequestStatus (options = {}) {
        return this.get({
            url: `${this.basePath}/loans/requests`,
            qs: _.defaultsDeep(options, defaultOptionsRequestsStatus)
        });
    }
}

export default new Loans();
